<template>
    <div class="badge-card" :class="{'reward': badgeStatus == 1}" @click="catBadgeDetailHandle">
        <!-- label -->
        <div class="badge-card-label">
            <div class="badge-card-label-view">
                <div class="badge-card-label-text">{{ label }}</div>
            </div>
        </div>
        <!-- badge Icon -->
        <div class="badge-card-icon">
            <!-- 图片 -->
            <img :src="badgeIcon" v-if="!isYuli">
            <div class="yuli-view" v-else>
                <img :src="badgeIcon || require('@/assets/images/YuliApp/badgeWall/badgeIcon/yuli.png')"/>
                <span class="yuli-view-id"
                      :class="{
                        'yuli-view-id-gold': isYuli?.role_type == 6
                      }">
                    #{{ isYuli?.id }}
                </span>
            </div>
            <!-- 感叹号（寄生） -->
            <div class="badge-card-gantanhao" v-show="badgeStatus == 1">
                <img :src="require('@/assets/images/YuliApp/badgeWall/RewardSignal.png')"/>
            </div>
        </div>
        <!-- jingdu - star -->
        <div class="badge-card-jingdu">
            <div class="badge-card-jingdu-line" 
                 :class="[{'badge-card-jingdu-line-light': index <= (nowStar || 0) }]"
                 v-for="index in (maxStar || 3)" 
                 :key="index">
            </div>
        </div>
        <!-- jianyu -->
        <div class="badge-card-jianyu">
            <div class="badge-card-jianyu-view">
                <div class="badge-card-jianyu-text">{{ jianyu }}</div>
            </div>
        </div>
        <!-- reward -->
        <div class="badge-card-reward">
            <!-- <div class="badge-card-reward-label">reward</div> -->
            <div class="badge-card-reward-box" v-for="(rewardItem, rewardIndex) in reward" :key="rewardIndex">
                <PropItem 
                    :propStyle="{
                        'scale': 0.72
                    }"
                    :prop_img="rewardItem?.url"
                    :prop_number="NumberFormatHanle(rewardItem?.number)"
                    :prop_type="rewardItem?.type"
                />
                <!-- light effect -->
                <div class="badge-card-reward-light-view-Abs" v-show="badgeStatus == 1">
                    <div class="badge-card-reward-light-view-Rel">
                        <!-- 光效-星星 -->
                        <div class="badge-card-reward-light">
                            <div class="hideBoxTop">
                                <img class="badge-card-reward-light-top" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                            </div>
                            <div class="hideBoxBottom">
                                <img class="badge-card-reward-light-bottom" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                            </div>
                            <div class="hideBoxLeft">
                                <img class="badge-card-reward-light-left" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                            </div>
                            <div class="hideBoxRight">
                                <img class="badge-card-reward-light-right" :src="require('@/assets/images/YuliApp/badgeWall/lightEffect_star.png')"/>
                            </div>
                        </div>
                        <!-- 光效呼吸 -->
                        <div class="badge-card-reward-light-view-breathe"></div>
                    </div>
                </div>
                <!-- 已领取 -->
                <div class="badge-card-reward-hadClaim" v-show="badgeStatus == 2">
                    <img :src="require('@/assets/images/YuliApp/badgeWall/btn_task_yes.png')"/>
                </div>
            </div>
        </div>
        <!-- reward process (ing) -->
        <div class="badge-card-process" v-show="badgeStatus == 0">
            <Process 
                :cur_kep="process?.currentNum"
                :total_kep="process?.total"
            />
        </div>
        <!-- button (end before) -->
        <div class="badge-card-buttonView" v-show="badgeStatus == 1">
            <div class="badge-card-buttonView-button" @click.stop="ClaimHandle(dataPackage)">
                {{ localesPackage?.['badgewall_claim']?.[localesEnv] }}
            </div>
        </div>
        <!-- time (end after) -->
        <div class="badge-card-timeView" v-show="badgeStatus == 2 && !isOther">
            <!-- <img :src="require('@/assets/images/YuliApp/badgeWall/icon_yes_gray.png')"/> -->
            <span class="badge-card-timeView-text">{{ getTimeHanlde((time * 1000), 'YYYY-MM-DD') }}</span>
        </div>
        <!-- other player reward -->
        <div class="badge-card-otherPlayer" v-show="isOther">{{ localesPackage?.['badgewall_claimed_by_other']?.[localesEnv] }}</div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import audioManager from "@/utils/audioManager";
import { mapState } from "vuex";
import Process from "../Process";
import PropItem from "../PropItem";
import { getTime, NumberFormat } from "@/utils/utils";

export default {
components: {
    Process,
    PropItem
},
props: {
    dataPackage:{
        type: Object,
        default: () => {
            return null
        }
    },
    label: {
        type: String,
        default: 'label',
    },
    badgeIcon: {
        type: String,
        default: require('@/assets/images/YuliApp/weeklyTask/goods_icon_kuguang@2x.png'),
    },
    nowStar: {
        type: Number,
        default: 1,
    },
    maxStar: {
        type: Number,
        default: 5,
    },
    jianyu: {
        type: String,
        default: 'jianyu jianyu jianyujianyu jianyu jianyu jianyujianyu jianyu jianyu jianyujianyujianyu jianyu jianyujianyujianyu jianyu jianyujianyu',
    },
    process: {
        type: Object,
        default: () => {
            return {
                currentNum: 0,
                total: 3
            }
        },
    },
    reward: {
        type: Object,
        default: () => {
            return {
                url: require('@/assets/images/YuliApp/weeklyTask/goods_icon_kuguang@2x.png'),
                number: 222,
                type: 2,
                name: 'name'
            }
        },
    },
    isYuli: {
        type: Object,
        default: () => {
            return null
        },
    },
    time: {
        type: Number,
        default: null
    },
    badgeStatus: {
        type: Number,
        default: 0, // 0 - 进行中， 1 - 待领取， 2已领取
    },
    isOther: {
        type: Boolean,
        default: false
    }
},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
        languageEnv: (state) => state.global.languageEnv,
        languagePackage: (state) => state.global.languagePackage,
    }),
},
watch: {
    languageEnv: {
        async handler(value) {
            if(value){
            this.localesEnv = value;
            }
        },
        immediate: true,
        deep: true,
    },
    languagePackage: {
        async handler(value) {
            if(value){
            this.localesPackage = value;
            }
        },
        immediate: true,
        deep: true,
    },
},
setup(props, { emit }) {
    const { dataPackage, total_kep } = props;
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const getTimeHanlde = getTime;
    const NumberFormatHanle = NumberFormat;

    /**
     * 获取星图的class
     * @param {*} index 
     * @param {*} maxStar 
     */
    const getStarClass = (index, maxStar) => {
        return {
            'stars-view-center': maxStar == 1 || 
                    (maxStar == 2 ) ||
                    (maxStar == 3 && index == 2) || 
                    (maxStar == 4 ) || 
                    (maxStar == 5 && index == 3),
            [`stars-view-item-${index}`]: true
        }
    }

    const catBadgeDetailHandle = () => {
        console.log('catBadgeDetailHandle');
        emit('handle', true, dataPackage);
    }

    const ClaimHandle = (itemInfo) => {
        console.log('ClaimHandle: ', itemInfo);
        emit('handle', 'claim', itemInfo);
    }

    return {
        getStarClass,
        catBadgeDetailHandle,
        ClaimHandle,
        getTimeHanlde,
        NumberFormatHanle,
        localesPackage,
        localesEnv,
    };
},
};
</script>
  
<style lang="less" scoped>
    @animTime: 2s;
    @lightSize: 52px;
    // 常规态 
    .badge-card{
        width: 158px;
        height: 286px;
        background: url("~@/assets/images/YuliApp/badgeWall/BadgeBg.png") no-repeat
        top left;
        background-size: 100% 100%;
        position: relative;
        // border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        padding-top: 15px;
        box-sizing: border-box;
        &-label{
            // margin-bottom: 1.8px;
            width: 86%;
            height: 30px;
            top: 8px;
            left: 50%;
            transform: translate(-50%, 0);
            position: absolute;
            &-view{
                width: 100%;
                height: 100%;
                position: relative;
            }
            &-text{
                width: 100%;
                color: #ffffffff;
                font-size: 14px;
                font-weight: 500;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 14px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                // overflow: hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-line-clamp: 2;
                // -webkit-box-orient: vertical;
            }
        }
        &-icon{
            margin-top: 16px;
            margin-bottom: 6px;
            width: 100px;
            height: 100px;
            position: relative;
            // border-radius: 50%;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-jingdu{
            display: flex;
            flex-direction: row;
            margin-bottom: 1px;
            &-line{
                // width: 15px;
                // height: 2px;
                // background-color: rgba(255, 255, 255, 0.22);
                width: 8px;
                height: 8px;
                background: url("~@/assets/images/YuliApp/badgeWall/jingdu_off.png") no-repeat
                top left;
                background-size: 100% 100%;
                margin-right: 3px;
            }
            &-line:last-child{
                margin-right: unset;
            }
            &-line-light{
                // background-color: rgba(255, 255, 255, 1);
                background: url("~@/assets/images/YuliApp/badgeWall/jingdu_on.png") no-repeat
                top left;
                background-size: 100% 100%;
            }
        }
        &-jianyu{
            width: 94%;
            height: 25px;
            // margin-bottom: 6px;
            &-view{
                width: 100%;
                height: 100%;
                position: relative;
                overflow: hidden;
            }
            &-text{
                width: 100%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                color: rgba(255, 255, 255, 1);
                font-size: 11px;
                font-weight: 400;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 12.5px;
            }
        }
        &-reward{
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            &-box{
                // margin: 0px auto;
                width: 48px;
                height: 48px;
                font-size: 12px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            &-light-view{
                &-Abs{
                    scale: 0.72;
                    position: absolute;
                    z-index: 2;
                    width: 60px;
                    height: 60px;      
                    // overflow: hidden;  
                }
                &-Rel{
                    position: relative;
                    width: 100%;
                    height: 100%;
                }
                &-breathe{
                    position: relative;
                    left: 0px;
                    top: 1px;
                    width: 100%;
                    height: 100%;
                    background: url("~@/assets/images/YuliApp/badgeWall/lightEffect_frame.png") no-repeat
                    top left;
                    background-size: 100% 100%;
                    // animation: breatheAni 2s linear infinite;
                }
            }
            &-light{
                position: absolute;
                width: @lightSize;
                height: @lightSize;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                // overflow: hidden;
                .hideBoxTop{
                    position: absolute;
                    top: -3px;
                    left: 0px;
                    width: @lightSize;
                    height: 11px;
                    overflow: hidden;
                }
                .hideBoxBottom{
                    position: absolute;
                    bottom: -3px;
                    right: 0px;
                    width: @lightSize;
                    height: 11px;
                    overflow: hidden;
                }
                &-top{
                    position: absolute;
                    top: 0px;
                    left: -33px;
                    visibility: hidden;
                    animation: translateTop @animTime linear infinite; /* 应用旋转光效动画 */
                    animation-fill-mode: both;
                }
                &-bottom{
                    position: absolute;
                    bottom: 0px;
                    right: -33px;
                    transform: rotate(180deg);
                    visibility: hidden;
                    animation: translateBottom @animTime linear infinite; /* 应用旋转光效动画 */
                    animation-fill-mode: both;
                }
                .hideBoxLeft{
                    position: absolute;
                    bottom: 0px;
                    left: -5px;
                    width: 11px;
                    height: @lightSize;
                    overflow: hidden;
                }
                .hideBoxRight{
                    position: absolute;
                    top: 0px;
                    right: -5px;
                    width: 11px;
                    height: @lightSize;
                    overflow: hidden;
                }
                &-left{
                    position: absolute;
                    bottom: -18px;
                    left: -12px;
                    transform: rotate(270deg);
                    visibility: hidden;
                    animation: translateLeft @animTime linear infinite; /* 应用旋转光效动画 */
                }
                &-right{
                    position: absolute;
                    top: -18px;
                    right: -12px;
                    transform: rotate(90deg);
                    visibility: hidden;
                    animation: translateRight @animTime linear infinite; /* 应用旋转光效动画 */
                }
                img{
                    width: 40px;
                    height: 10px;
                }
            }
            // 旋转特效组件 - 上部件
            @keyframes translateTop {
                0% {
                    visibility: visible;
                    transform: translateX(0);
                }
                45% {
                    transform: translateX(calc(@lightSize + 33px));
                }
                46%{
                    visibility: hidden;
                }
                62% {
                    visibility: hidden;
                    transform: translateX(0);
                }
                63%{
                    visibility: visible;
                    transform: translateX(0);
                }
                100%{
                    transform: translateX(calc(@lightSize + 33px));
                }
            }
            // 旋转特效组件 - 下部件
            @keyframes translateBottom {
                0% {
                    visibility: visible;
                    transform: rotate(180deg) translateX(0);
                }
                45% {
                    transform: rotate(180deg) translateX(calc(@lightSize + 33px));
                }
                46%{
                    visibility: hidden;
                }
                62% {
                    visibility: hidden;
                    transform: rotate(180deg) translateX(0);
                }
                63%{
                    visibility: visible;
                    transform: rotate(180deg) translateX(0);
                }
                100%{
                    transform: rotate(180deg) translateX(calc(@lightSize + 33px));
                }
            }
            // 旋转特效组件 - 左部件
            @keyframes translateLeft {
                0% {
                    visibility: hidden;    
                }
                31% {
                    visibility: hidden;
                }
                32%{
                    visibility: visible;
                    transform: rotate(270deg) translateX(0);
                }
                82%{
                    visibility: visible;
                    transform: rotate(270deg) translateX(calc(@lightSize + 33px));
                }
                83%{
                    visibility: hidden;
                }
                100% {
                    visibility: hidden;
                }
            }
            // 旋转特效组件 - 右部件
            @keyframes translateRight {
                0% {
                    visibility: hidden;    
                }
                31% {
                    visibility: hidden;
                }
                32%{
                    visibility: visible;
                    transform: rotate(90deg) translateX(0);
                }
                82%{
                    visibility: visible;
                    transform: rotate(90deg) translateX(calc(@lightSize + 33px));
                }
                83%{
                    visibility: hidden;
                }
            }
            // 呼吸
            @keyframes breatheAni {
                0% {
                    scale: 0.98;
                }
                50%{
                    scale: 1.02;
                }
                100% {
                    scale: 0.98;
                }
            }
            &-hadClaim{
                scale: 0.72;
                position: absolute;
                width: 48px;
                height: 48px;
                background-color: rgba(0, 0, 0, 0.4);
                z-index: 5;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 23px;
                    height: 23px;
                }
            }
        }
        &-process{
            margin-top: 12px;
            width: 112px;
            height: 12px;
            position: relative;
        }
        &-buttonView{
            margin-top: 7px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            &-button{
                background: url("~@/assets/images/YuliApp/badgeWall/RewardButtonBg.png") no-repeat
                top left;
                background-size: 100% 100%;
                width: 91px;
                height: 28px;
                color: rgba(37, 38, 42, 1);
                font-size: 13px;
                font-weight: 600;
                font-family: "PingFang SC";
                text-align: center;
                line-height: 28px;
            }
        }
        &-timeView{
            margin-top: 6px;
            width: 91px;
            height: 28px;
            background: url("~@/assets/images/YuliApp/badgeWall/RewardTimeBg.png") no-repeat
            top left;
            background-size: 100% 100%;
            position: relative;
            &-text{
                position: absolute;
                top: 55%;
                transform: translateY(-50%);
                right: 6px;
                width: fit-content;
                word-break: keep-all;
                height: 14px;
                opacity: 1;
                color: #489379;
                font-size: 11px;
                font-weight: 500;
                // scale: 0.85;
                font-family: "PingFang SC";
                text-align: center;
                // letter-spacing: -0.21px;
            }
            img{
                position: absolute;
                left: 12px;
                top: 50%;
                transform: translateY(-50%);
                width: 14.93px;
                height: 14.93px;
            }
        }
        &-gantanhao{
            width: 14px;
            height: 14px;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: -26px;
            right: -27.5px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-otherPlayer{
            width: 157px;
            margin: 0 auto;
            margin-top: 6px;
            color: #F3DA52;
            font-size: 12px;
            font-weight: 400;
            font-family: "PingFang SC";
            text-align: center;
        }
    }
    // 领取态
    .reward{
        background: url("~@/assets/images/YuliApp/badgeWall/hadChooseBadgeBg.png") no-repeat
        top left;
        background-size: 100% 100%;
        .badge-card-label{
            &-text{
                color: #FEEFAF;
                font-size: 15px;
                font-weight: 500;
            }
        }
        .badge-card-jianyu{
            &-text{
                // color: rgba(255, 248, 224, 0.8);
                color: #fff;
            }
        }
        // 领取道具状态
        .badge-card-reward{
            &-box{
                position: relative;
            }
        }
    }
    // yuli情况
    .yuli-view{
        position: relative;
        &-id{
            position: absolute;
            bottom: 26px;
            right: 50%;
            transform: translate(50%, 0);
            color: #F2F2F2;
            font-size: 12px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            text-shadow: 0 1px 2px rgba(64, 41, 17, 0.56), 1px 0 2px rgba(64, 41, 17, 0.56), -1px 0 2px rgba(64, 41, 17, 0.56), 0 -1px 2px rgba(64, 41, 17, 0.56);
            &-gold{
                color: #fffde7;
            }
        }
    }
    @media screen and (max-width: 375px){
        .badge-card{
            &-timeView{
                width: 101px;
                &-text{
                    font-size: 6px;
                }
            }
        }
    }
</style>
  